import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FavoriteItem {
  id: string;
  type: 'cat' | 'product';
}

interface FavoritesStore {
  items: FavoriteItem[];
  toggleFavorite: (id: string, type: 'cat' | 'product') => void;
  isFavorite: (id: string, type: 'cat' | 'product') => boolean;
  getFavorites: (type?: 'cat' | 'product') => FavoriteItem[];
  getCount: () => number;
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      items: [],

      toggleFavorite: (id: string, type: 'cat' | 'product') => {
        const { items } = get();
        const exists = items.some(item => item.id === id && item.type === type);
        if (exists) {
          set({ items: items.filter(item => !(item.id === id && item.type === type)) });
        } else {
          set({ items: [...items, { id, type }] });
        }
      },

      isFavorite: (id: string, type: 'cat' | 'product') => {
        return get().items.some(item => item.id === id && item.type === type);
      },

      getFavorites: (type?: 'cat' | 'product') => {
        const { items } = get();
        if (!type) return items;
        return items.filter(item => item.type === type);
      },

      getCount: () => get().items.length,
    }),
    {
      name: 'cat-care-favorites',
      partialize: (state) => ({ items: state.items }),
    }
  )
);
